import React, { useState, Fragment, useEffect } from "react";
import { /* Form, */ Button, Card, Row, Container, InputGroup, FormControl, } from "react-bootstrap";
import { Transaction } from "../../../../services/product.service";
import { FormatMoney, Capitalize } from "../../../../utilities/formats";
import { LoadingMovilGoSoat } from "../../../../shared/components/loadingMovilGo";
import { ModalNotificationTransactionSoat } from "../../../../shared/components/modalNotificationTransaction";
import { jsPdfGenerator } from "../../../../shared/components/pdfTransaction";
import Select from "react-select";
import { DateToString } from "../../../../utilities/formats";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const SendPolicy = (props) => {
  const { data, date, dataContact, productId, closeAction, loading, setLoading } = props;

  /* const [cellular, setCellular] = useState("3245657845");
  const [email, setEmail] = useState("jaimealbertogaviria@reactiva.com.co"); */
  const [cellular, setCellular] = useState("");
  const [email, setEmail] = useState("");
  /* const [cellular, setCellular] = useState("");
  const [email, setEmail] = useState(""); */
  const [modalNotification, setModalNotificacion] = useState(false);
  const [response, setResponse] = useState([]);

  const [iva, setIva] = useState(false);
  const [tipoCiud, setTipoCiud] = useState({ label: "-- Seleccione una opcion --", value: "" });
  const vehicle = data.soat.respuesta_vehiculo;
  const tarifa = data.soat.respuesta_tarifa;

  const contact = data.soat.respuesta_cliente;

  const ciudOption = [
    { label: "Gran Contribuyente", value: 1 },
    { label: "Autorretenedor", value: 2 },
    { label: "Agente de retencion Iva", value: 3 },
    { label: "Regimen simple de tributacion", value: 4 },
    { label: "No aplica", value: 5 },
    { label: "Contribuyente - Autorretenedor - Agente de Retencion Iva", value: 6, },
    { label: "Autorretenedor-Agente de Retencion Iva", value: 7 },
    { label: "Gran Contribuyente-Agente de Retencion Iva", value: 8 },
  ];

  let Law2161Discount = ''
  let Law2161Discount2 = ''
  let GasDiscount = ''
  let PercentageGasDiscount = ''
  let GasDiscountFormatted = ''
  let TotalLawDiscountFormatted = ''

  const clearData = () => {
    setEmail("");
    setCellular("");
    setLoading(false);
  };

  //console.log("Datos variable date SENDPOLy", props.date);  

  const verifyData = () => {
    //console.log("esto es el IVA2", iva);
    const emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if (cellular.trim() === "") {
      alert("Error" + ", El celular Este  es obligatorio");
      if (alert) {
        clearData();
      }
    } else if (cellular.length !== 10) {
      alert("Error" + " El celular es inválido");
      if (alert) {
        clearData();
      }
    } else if (email.trim() === "") {
      alert("Error" + ", El email es obligatorio");
      if (alert) {
        clearData();
      }
    } else if (!emailValid) {
      alert("Error" + ", El email es  inválido");
      if (alert) {
        clearData();
      }
    } else {
      sendData(true);
    }
  };

  const sendData = (flag) => {
    /* const datedate = props.date
    const newDate = DateToString(datedate, true, 0, 0, 1)
    console.log("NEWnewDate", newDate) */

    if (flag) {
      setLoading(true);
      let numIva = "2";
      if (iva) {
        numIva = "1";
      }
      if (tipoCiud.value === "") {
        tipoCiud.value = 5;
      }

      const datee = /* this.state */props.date.split("-");
      //console.log("LET DATE: ", datee)
      const year = parseInt(datee[0]);// + 1; 
      /* const year = parseInt(datee[0]) - 1;*/
      //console.log("LET YEAR: ", year)

      const preparedData = {
        Contact: {
          Address: {
            CityId: dataContact.city,
            Name: dataContact.adress.replace(".", ""),
            StateId: dataContact.StateId,
          },
          CiiuId: dataContact.CiiuId,
          Cellular: cellular,
          DocumentNumber: dataContact.document,
          DocumentTypeId: dataContact.DocumentTypeId,
          Email: email.trim(),
          FirstName: Capitalize(dataContact.firstName.split(" ")[0] ?? ""),
          FirstName1: Capitalize(dataContact.firstName.split(" ")[1] ?? ""),
          LastName: Capitalize(dataContact.lastName.split(" ")[0] ?? ""),
          LastName1: Capitalize(dataContact.lastName.split(" ")[1] ?? ""),
          Phone: cellular,
        },
        //PENDIENTE VERIFICAR QUE MANDA
        FromValidateDate: year + "-" + datee[1] + "-" + datee[2],//date,//DateToString(date, true, 0, 0, 1),//
        RegimenTypeId: numIva,
        Rutid: tipoCiud.value, //Preguntar
        SendPolicy: {
          Address: dataContact.city,
          Cellular: cellular,
          CityId: "17001",
          Email: email.trim(),
        },
        SystemSource: 10,
        ChangeEmisionType: 1,
        Vehicle: {
          BrandId: vehicle.BrandId,
          ChasisNumber: vehicle.ChasisNumber,
          CylinderCapacity: vehicle.CylinderCapacity,
          LoadCapacity: vehicle.LoadCapacity,
          MotorNumber: vehicle.MotorNumber,
          NumberPlate: vehicle.NumberPlate,
          PassengerCapacity: vehicle.PassengerCapacity,
          ServiceTypeId: vehicle.ServiceTypeId,
          VIN: vehicle.Vin,
          VehicleClassId: vehicle.VehicleClassId,
          VehicleClassMinistryId: vehicle.VehicleClassMinistryId,
          VehicleLineDescription: vehicle.VehicleLineDescription,
          VehicleLineId: vehicle.VehicleLineId,
          VehicleYear: vehicle.VehicleYear,
          VehicleBodyTypeId: vehicle.VehicleBodyTypeId,
          FuelTypeId: vehicle.FuelTypeId,
          ////
          EnginePowerTypeId: vehicle.EnginePowerTypeId,
        },
        Payments: [
          {
            MethodOfPaymentId: 1,
            ReferenceNumber1: null,
            ReferenceNumber2: null,
            PaymentAmount: tarifa.TotalWithDiscountAmount,
            Observation: null,
          },
        ],
      };
      // console.log("preparedData WEB:",preparedData) 
      // console.log("FromValidateDate", preparedData.FromValidateDate);
      // console.log("productIdMOVIL",productId) 
      /* console.log("VARIABLE CON Vehicle.ServiceTypeId", preparedData.Vehicle.ServiceTypeId); */
      Transaction({ product_id: productId, atributes: preparedData }, navigateNext);
    }
  };

  const navigateNext = (flag, response) => {
    //console.log("FLAG RESPONSE", flag, response)

    if (flag) {
      setResponse(response);
      setModalNotificacion(true);
      setLoading(false);
    } else {
      //console.log("FLAG RESPONSE", flag, response)
      if (response.errores) {
        if (response.errores.observacion) {
          const error = () => toast.error("Error " + response.errores.observacion);
          error();
          /* alert("Error, " + response.errores.observacion);
          if (alert) { */
          if (error) {
            clearData();
          }
        } else {
          const error = () => toast.error("Error " + " No se pudo relizar la transaccion");
          error();
          /*  alert("Error, " + "No se pudo relizar la transaccion");
          if (alert) {  */
          if (error) {
            clearData();
          }
        }
      } else {
        //console.log("FLAG RESPONSE3", flag, response)
        const error = () => toast.error("Error " + " Se ha presentado un error de conexion");
        error();
        /* alert("Error " + " Se ha presentado un error de conexion");
        if (alert) { */
        if (error) { clearData(); }
      }
    }
  };

  const closeModal = (flag) => {

    setModalNotificacion(flag);

    const data = [
      "Factura No: " + response.valida.id,
      "Fecha:" + response.valida.fecha,
      "No. Aprobación: " + response.valida.numero_aprobacion,
      "Producto: Soat",
      "Celular: " + cellular,
      "Cedula: " + dataContact.document,//contact.DocumentNumber,
      "Cliente: " + dataContact.firstName + ' ' + dataContact.lastName,
      /* "Cliente: " +
        contact.FirstName +
        " " +
        contact.FirstName1 +
        " " +
        contact.LastName +
        " " +
        contact.LastName, */
      "Placa: " + vehicle.NumberPlate,
      "Valor: " + FormatMoney(tarifa.TotalWithDiscountAmount),
    ];

    jsPdfGenerator(data);
    closeAction(true);
  };

  const loadData = () => {
    if (vehicle.NewTariff != null) {
      //console.log("tarifa.Law2161Discount", tarifa.Law2161Discount.Percentage)
      //Law2161Discount=vehicle.NewTariff.Law2161Discount
      Law2161Discount = tarifa.Law2161Discount.Percentage
      Law2161Discount2 = tarifa.Law2161Discount.Percentage
      GasDiscount = vehicle.NewTariff.GasDiscount
      PercentageGasDiscount = vehicle.NewTariff.PercentageGasDiscount
      GasDiscountFormatted = vehicle.NewTariff.GasDiscountFormatted
      TotalLawDiscountFormatted = vehicle.NewTariff.TotalLawDiscountFormatted
    }
    //console.log("Law2161Discount2",Law2161Discount2) 
  }
  useEffect(() => {
    loadData();
  }, []);

  return (
    <div style={{ backgroundColor: "white" }}>
      <div style={styles.container}>
        <Container><ToastContainer />
          <Row className="justify-content-md-center">
            <Card className="reloadsCard"
              style={{ minWidth: "95%", borderColor: "#078FA5"/* , align: "center" */ }}
            >
              <Card.Body style={{ align: "center" }}>
                <div style={{ margin: 5, borderWidth: 1, padding: 5, borderColor: "#078FA5", borderRadius: 10, }} >
                  <div style={{ borderBottomWidth: 1, backgroundColor: "#07A2BA", textAlign: "center", }} >
                    <p style={{ fontWeight: "bold" }}>Datos Compra</p>
                  </div>
                  <div style={{ borderBottomWidth: 1, textAlign: "center" }}>
                    <p style={styles.title}>Tarifa</p>
                  </div>

                  <div style={styles.rowContainer} className="row">
                    <div style={styles.colContainer}>
                      <p style={styles.title}>V Prima</p>
                      <p>{tarifa.InsurancePremium}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Contribucion</p>
                      <p>{tarifa.InsuranceTaxFormatted}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>RUNT</p>
                      <p>{tarifa.InsuranceFineFormatted}</p>
                    </div>
                  </div>

                  <div style={styles.rowContainer} className="row">
                    {/* <div style={styles.colContainer}> <p style={styles.title}>Descuento</p>
                              <p>{tarifa.ElectricDiscount > 0 ? '-' : ''}$ {tarifa.ElectricDiscount}</p> </div> */}

                    <div style={styles.colContainer}>
                      <p style={styles.title}>Total Soat</p>
                      <p>$ {tarifa.Total + tarifa.ElectricDiscount}</p>
                    </div>
                    {/* <div style={styles.colContainer}> <p style={styles.title}>Porcentaje desc</p>
                              <p>{tarifa.PercentageElectricDiscount}%</p> </div> */}
                    <div style={styles.colContainer}>
                      <p style={styles.title}>T. Combustible</p>
                      <p>{vehicle.FuelTypeId}</p>
                    </div>
                  </div>

                  <div style={styles.rowContainer2} className="row">
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Dto. ley 2161</p>
                      {/* <p>$ {Law2161Discount}</p> */}
                      <p>{tarifa.Law2161Discount.Amount ? tarifa.Law2161Discount.Amount : 0}
                        {/* {tarifa.Law2161Discount.TotalLaw2161DiscountFormatted} */}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>% Dto. ley 2161</p>
                      {/* <p>$ {Law2161Discount2}</p> */}
                      <p>{tarifa.Law2161Discount.Percentage ? tarifa.Law2161Discount.Percentage : 0}%
                        {/* {tarifa.Law2161Discount.Percentage} */}</p>
                    </div>
                  </div>

                  <div style={styles.rowContainer2} className="row">
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Dto. por Gas</p>
                      <p>$ {tarifa.GasDiscount}
                        {/* $ {GasDiscount} */}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>% Dto. por Gas</p>
                      <p>{tarifa.PercentageGasDiscount}%{/* 
                                 {PercentageGasDiscount}% */}</p>
                    </div>
                  </div>

                  <div style={styles.rowContainer2} className="row">
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Total de Dto</p>
                      <p>$ {vehicle.TotalLawDiscount ? vehicle.TotalLawDiscount : 0}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Total de Dto a Gas</p>
                      <p>{tarifa.GasDiscountFormatted}{/* {GasDiscountFormatted} */}</p>
                    </div>
                  </div>

                  <div style={styles.rowContainer2} className="row">
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Total con desct</p>
                      <p>{tarifa.TotalWithDiscountAmountFormatted}
                        {/* {tarifa.TotalFormatted} */}</p>
                    </div>
                    <div style={styles.colContainer}>
                      <p style={styles.title}>Total todos desct</p>
                      <p>{tarifa.TotalLawDiscountFormatted}</p>
                    </div>
                  </div>

                  <div style={{ fontWeight: "bold", textAlign: "center" }}>
                    <input type="checkbox" checked={iva}
                      onChange={(e) => { setIva(e.target.checked); }}
                    />
                    <label> Responsable de iva</label>
                  </div>

                  {iva && (<div>
                    <Fragment>
                      <Select className="basic-single" classNamePrefix="select"
                        value={tipoCiud} isDisabled={false} isLoading={false}
                        isClearable={true} isRtl={false} isSearchable={true}
                        name="color"
                        options={ciudOption}
                        onChange={(value) => { setTipoCiud(value); }}
                      />
                    </Fragment>
                  </div>
                  )}
                </div>
                {/* <ToastContainer /> */}
                {/* <Row className="justify-content-md-center"> */}
                {/* <Card className="reloadsCard" style={{ minWidth: "95%", align: "center" }} > */}
                {/* <Card.Body style={{ align: "center" }}> */}
                <InputGroup className="mb-2">
                  <FormControl placeholder="Celular" maxLength={10}
                    arial-label="Amount (to the nearest dollar)"
                    value={cellular}
                    onChange={(e) => { setCellular(e.target.value.replace(/\D/, "")); }}
                  />
                </InputGroup>
                <InputGroup className="mb-2">
                  <FormControl placeholder="Email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); }}
                  />
                </InputGroup>

                <div className="mb-2" style={{ align: "center", textAlign: "center" }} >
                  <Button onClick={verifyData}/* title="Comprar"  */
                    style={{ backgroundColor: "#07A2BA", width: "50%" }}
                  > Comprar
                  </Button>
                </div> {/*</Card.Body> </Card> </Row> </Container> */}
                {modalNotification && (<ModalNotificationTransactionSoat
                  closeModal={(flag) => closeModal(flag)} type={"Soat"}
                  message={"Compra realizada exitosamente"}
                />
                )}
                {loading && <LoadingMovilGoSoat style={{ marginleft: "20%" }} />}
              </Card.Body>
            </Card>
          </Row>
        </Container>
      </div>
    </div>
  );
};

const styles = {
  title: {
    fontWeight: "bold",
  },
  container: {
    paddingHorizontal: 10,
    maxHeight: "100%",

    /* backgroundColor: '#078FA5' */
  },
  titleSummary: {
    alignSelf: "center",
    fontWeight: "bold",
    fontSize: 18,
    color: "#07A2BA",
  },
  colContainer: {
    width: "32%",
  },
  rowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 5,
  },
  rowContainer2: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 25,
  },
  loading: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
  },
};
